import React, {useEffect} from 'react';
import Heading from "../../../components/services/heading/Heading.tsx";
import classes from '../Services.module.scss'
import BlackCardWithIcon from "../../../components/black-card-with-icon/BlackCardWithIcon.tsx";
import WhiteEmojiCard from "../../../components/white-emoji-card/WhiteEmojiCard.tsx";
import GrayCardBlueIcon from "../../../components/gray-card-blue-icon/GrayCardBlueIcon.tsx";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {Link} from "react-scroll";
import arrowIcon from '../../../media/icons/arrow-right-plain.svg'
import FrequentlyAskedQuestions, {
    IQuestion
} from "../../../components/frequently-asked-questions/FrequentlyAskedQuestions.tsx";
import FormCard from "../../../components/formCard/FormCard.tsx";
import Industries from "../../../components/industries/Industries.tsx";
import {Helmet} from "react-helmet-async";
import { useTranslation } from 'react-i18next';

const settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.05,
    slidesToScroll: 1,
};

const SoftwareImplementationAndSupport = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const title = t('softwareImplementationAndSupport.title');;
    const description = t('softwareImplementationAndSupport.description', {returnObjects: true});
    const buttonText = t('softwareImplementationAndSupport.buttonText');

    const blackBlocks = t('softwareImplementationAndSupport.blackBlocks', {returnObjects: true});

    const emojiBlocks = t('softwareImplementationAndSupport.emojiBlocks', {returnObjects: true})

    const servicesBlocks = t('softwareImplementationAndSupport.servicesBlocks', {returnObjects: true})
    const dropDownBlocks = t('softwareImplementationAndSupport.processBlocks', {returnObjects: true})


    

    const questions: { left: IQuestion[]; right: IQuestion[] } = {
            left: t('softwareImplementationAndSupport.Faq.left', {returnObjects: true}),
            right: t('softwareImplementationAndSupport.Faq.right', {returnObjects: true}),
    };

    return (
        <>
            <Helmet>
                <title>
                    Software Implementation and Support Services | Reliable IT Support | Goteco
                </title>
                <meta
                    name="description"
                    content="Professional software implementation and support services. We ensure seamless system deployment, integration with existing infrastructure, and ongoing maintenance for stable business operations."
                />
                <link rel="canonical" href="https://go-te.co/services/software-implementation-and-support" />
            </Helmet>
            <main>
            <Heading title={title} description={description} buttonText={buttonText}/>
            <section className={`${classes['blocks-right']} section--light-gray`}>
                <h2>{t('softwareImplementationAndSupport.blackBlocksTitle')}</h2>
                <div className={classes['blocks-container']}>
                    {blackBlocks.map(({icon, text}) => <BlackCardWithIcon key={icon} iconName={icon} text={text}/>)}
                </div>
            </section>

            <section className={`${classes['text-with-emoji-cards']} section--white`}>
                <div>
                    <h2>{t('softwareImplementationAndSupport.whatIsIt')}</h2>
                    <div>
                        <p>{t('softwareImplementationAndSupport.whatIsItText')}</p>
                        <p>{t('softwareImplementationAndSupport.whatIsItText2')}</p>
                    </div>
                </div>
                <div>
                    <div className={classes['blocks-container']}>
                        {emojiBlocks.map(({icon, text}) => <WhiteEmojiCard key={icon} icon={icon} text={text}/>)}
                    </div>
                    <div className={classes['blue-block']}>
                        {t('softwareImplementationAndSupport.whatIsItBottom')}
                    </div>
                </div>
            </section>

            <section className={`${classes['services-container']} section--dark-gray`}>
                <h2>{t('softwareImplementationAndSupport.ourItCons')}</h2>
                <span>{t('softwareImplementationAndSupport.ourItConsText')}</span>
                <div className={classes['blocks-container']}>
                    {servicesBlocks.map(({icon, text, title}) =>
                        <GrayCardBlueIcon iconName={icon} title={title} text={text} key={title}/>
                    )}
                </div>
                <Slider {...settings} className={classes.slider}>
                    {servicesBlocks.map(({icon, text, title}) =>
                        <GrayCardBlueIcon iconName={icon} title={title} text={text} key={title}/>
                    )}
                </Slider>
            </section>

            <section className={'section--dark-gray'}>
                <div className={classes["container"]}>
                    <div className={classes["left"]}>
                        <h2 className={classes["header"]}>{t('softwareImplementationAndSupport.process')}</h2>
                        <p className={classes["text"]}>
                            {t('softwareImplementationAndSupport.processText')}
                        </p>
                        <Link className={classes.button} smooth={true} to="contact">
                            <span>{buttonText}</span><img alt="" src={arrowIcon}/>
                        </Link>
                    </div>

                    <div className={classes["right"]}>
                        <div className={classes["drop-down"]}>
                            {dropDownBlocks.map((block, index) => (
                                <div key={index} className={classes["drop-down__block"]}>
                                    <div className={classes["top"]}>
                                        <div className={classes["drop-down__block__title"]}>
                                            {block.title}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className={`section--white ${classes.industries}`}>
                <div>
                    <h2>{t('softwareImplementationAndSupport.industriesWeServe')}</h2>
                </div>
                <div>
                    <Industries/>
                </div>
            </section>

            <section className="section--light-gray" id="nav-dark">
                <FrequentlyAskedQuestions title={t('softwareImplementationAndSupport.Faq.title')} questions={questions}/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard
                    title={t('softwareImplementationAndSupport.formCard.title')}
                    subtitle={t('softwareImplementationAndSupport.formCard.subtitle')}
                    message={t('softwareImplementationAndSupport.formCard.message')}
                    buttonText={t('softwareImplementationAndSupport.buttonText')}
                    labels={t('softwareImplementationAndSupport.formCard.labels',  {returnObjects: true})}
                    top={3}
                    id='contact'
                />
            </section>
        </main>
        </>
    );
};

export default SoftwareImplementationAndSupport;